import API from '../utils/axiosApiHR';
// import { printFrame } from '../helpers/common';
import FileSaver from 'file-saver';

/**Adjustment */
export const fetchAssetAdjustments = async (params) => {
  try {
    const { data } = await API.get('/assets/adjustments', { params });
    return data;
  } catch (error) {
    throw error;
  }
};
export const saveAssetAdjustment = async (body) => {
    try {
      if(body && body.CODE) {
        const { data } = await API.put(`/assets/adjustment/${body.CODE}`, body);
        return data;
      } else {
        const { data } = await API.post('/assets/adjustment', body);
        return data;
      }
    } catch (error) {
      throw error;
    }
};
export const getAssetAdjustment = async ({Code}) => {
  try {
    const { data } = await API.get(`/assets/adjustment/${Code}`);
    return data;
  } catch (error) {
    throw error;
  }
};
export const deleteAssetAdjustment = async ({Code}) => {
  try {
    const { data } = await API.delete(`/assets/adjustment/${Code}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const confirmAssetAdjustment = async (body) => {
  try {
    const { data } = await API.post(`/assets/adjustment/confirm`, body);
    return data;
  } catch (error) {
    throw error;
  }
};

export const printAssetAdjustment = async ({Code}) => {
  try {
    const response = await API.get(`/assets/adjustment/print/${Code}`, {
      responseType: 'blob'
    });
    const { data } = response;
    const namefile = response.headers['pcs-filename-suggestion'];
    let blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    FileSaver.saveAs(blob, namefile);
    return true;
  } catch (error) {
    throw error;
  }
};
